import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Md5 } from 'ts-md5';
import { HttpService } from '@app/core/http/http.service';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  standalone: false
})
export class AvatarComponent implements OnInit, OnChanges {
  @Input() seed: string = 'Adrian';
  @Input() forceAvatar = false;

  backgroundColor = 'f5f6fa';
  dicebearBaseSrc = 'https://api.dicebear.com/9.x/lorelei-neutral/svg?seed=';
  avatarSrc = this.dicebearBaseSrc + this.seed + '&backgroundColor=' + this.backgroundColor;

  isLoading = true;

  gravatarUrl = '';

  constructor(private http: HttpService) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    this.changeAvatar(changes.seed.currentValue, changes.seed.previousValue);
  }

  private changeAvatar(currentSeed?: string, previousSeed?: string) {
    if (!currentSeed || currentSeed === previousSeed) {
      return;
    }

    if (!window.Blob || !/@/.test(currentSeed) || this.forceAvatar) {
      this.generateAvatarUrl();
    } else {
      const gravatarUrl = 'https://www.gravatar.com/avatar/' + Md5.hashStr(currentSeed.trim()) + '?s=80&d=blank';
      this.http
        .disableLoader()
        .cache({ expiresIn: 604800 })
        .get(gravatarUrl, { responseType: 'blob' })
        .subscribe({
          next: (data: { size: number }) => {
            if (data.size <= 140) {
              this.generateAvatarUrl();
            } else {
              this.isLoading = false;
              this.avatarSrc = gravatarUrl;
            }
          },
          error: () => this.generateAvatarUrl()
        });
    }
  }

  generateAvatarUrl() {
    this.avatarSrc = this.dicebearBaseSrc + this.seed + '&backgroundColor=' + this.backgroundColor;
  }
}
